import { useQuery } from 'react-query'

import { financialAccountRepository } from '@webapp/platform/banking/data-access/repositories/FinancialAccountRepository'
import { financialAccountKeys } from '@webapp/platform/banking/data-access/repositories/FinancialAccountRepository/queryKey.factory'
import { FinancialAccountBankingDetails } from '@webapp/platform/banking/entities/FinancialAccountBankingDetails/FinancialAccountBankingDetails'

type UseQueryFinancialAccountBankingDetailsReturn = {
  accountDetails: Nullable<FinancialAccountBankingDetails>
  isFetching: boolean
}

export const useQueryFinancialAccountBankingDetails = ({
  financialAccountId,
  onError,
  enabled = true,
}: {
  financialAccountId: number
  onError?: () => void
  enabled?: boolean
}): UseQueryFinancialAccountBankingDetailsReturn => {
  const { data, isFetching } = useQuery({
    queryKey: financialAccountKeys.getAccountDetails,
    queryFn: () =>
      financialAccountRepository.getFinancialAccountBankingDetails(
        financialAccountId
      ),
    onError,
    enabled,
  })

  const accountDetails = data?.data

  return {
    accountDetails: accountDetails
      ? new FinancialAccountBankingDetails(accountDetails)
      : null,
    isFetching,
  }
}
